/** A research or run status as a pill: pending shows a spinner, failure a warning, the rest a check; always with its word. */

import { CheckCircle2, Loader2, TriangleAlert } from 'lucide-react';

import type { ResearchStatus, RunStatus } from '@/api/types';

export const isPending = (status: ResearchStatus | RunStatus | undefined) =>
  status === 'queued' || status === 'researching' || status === 'running';

const STATUS_LABEL: Record<ResearchStatus | RunStatus, string> = {
  queued: 'Queued',
  researching: 'Researching',
  running: 'Researching',
  scored: 'Scored',
  succeeded: 'Succeeded',
  failed: 'Failed',
};

export function ResearchStatusPill({ status }: { status: ResearchStatus | RunStatus }) {
  if (isPending(status)) {
    return (
      <span className="badge badge-info">
        <Loader2 aria-hidden="true" className="spin" />
        {STATUS_LABEL[status]}
      </span>
    );
  }
  if (status === 'failed') {
    return (
      <span className="badge badge-danger">
        <TriangleAlert aria-hidden="true" />
        Failed
      </span>
    );
  }
  return (
    <span className="badge badge-neutral">
      <CheckCircle2 aria-hidden="true" />
      {STATUS_LABEL[status]}
    </span>
  );
}
